import axiosServices from './request';

const Digital = axiosServices('digital');

export default {
  /** 获取最后来源书 */
  getUserLatestBook: Digital('get', 'digitalBookRecord/getUserLatestBook'),

  // 广告弹窗
  getCoursePop: Digital('get', 'bookRecomment/getCoursePop'),
  getPayInfo: Digital('get', 'bookAiServeConfig/getPayInfo')
};
